import { useDisclosure } from '@chakra-ui/react';

interface UseContactModalProps {
  defaultMessage?: string;
  defaultInterest?: string;
  title?: string;
  submitButtonText?: string;
}

const CONTACT_MODAL_PRESETS = {
  startModeling: {
    defaultInterest: 'pricing',
    title: 'Start Modeling',
    submitButtonText: 'Submit Application',
  },
  contactSales: {
    defaultInterest: 'sales',
    title: 'Contact Sales',
    submitButtonText: 'Submit Application',
  },
  signup: {
    defaultInterest: 'signup',
    title: 'Begin your journey into the tomorrow of MMM today',
    submitButtonText: 'Submit Application',
  },
} as const;

export type ContactModalPreset = keyof typeof CONTACT_MODAL_PRESETS;

export const useContactModal = (
  propsOrPreset: UseContactModalProps | ContactModalPreset = {},
) => {
  const props: UseContactModalProps =
    typeof propsOrPreset === 'string'
      ? CONTACT_MODAL_PRESETS[propsOrPreset]
      : propsOrPreset;

  const { defaultMessage, defaultInterest, title, submitButtonText } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();

  return {
    isOpen,
    onOpen,
    onClose,
    modalProps: {
      isOpen,
      onClose,
      defaultMessage,
      defaultInterest,
      title,
      submitButtonText,
    },
  };
};
